import { useCallback } from "react";
import { useRecaptchaContext } from "@/components/RecaptchaProvider";

export const useRecaptcha = () => {
  const { executeRecaptcha, isReady } = useRecaptchaContext();

  const getToken = useCallback(
    async (action: string): Promise<string | null> => {
      if (!executeRecaptcha) {
        console.warn("reCAPTCHA not ready");
        return null;
      }
      try {
        const token = await executeRecaptcha(action);
        return token;
      } catch (error) {
        console.error("reCAPTCHA error:", error);
        return null;
      }
    },
    [executeRecaptcha]
  );

  return { getToken, isReady };
};
